module.exports = __webpack_public_path__ + "static/media/mountains.d152b5d7.svg";